import { useCallback, useState, FunctionComponent, useEffect } from 'react';

import { Center, Heading, Text, Button, Code } from '@chakra-ui/react';
import SwipeableViews from 'react-swipeable-views';
import Mnemonic from '../../components/mnemonic/mnemonic';
import PageBody from '../../components/pageBody/pageBody';
import BottomActions from '../../components/bottomActions/bottomActions';
import { useHistory } from 'react-router-dom';

type GuideScreenProps = {};

const GuideScreen = (props: GuideScreenProps) => {
    const history = useHistory();
    const [step, setStep] = useState(0);

    const handleStepChange = useCallback((index: number) => setStep(index), [
        step,
    ]);

    const handleNext = useCallback(() => {
        setStep(step + 1);
    }, [step]);

    const handlePrev = useCallback(() => {
        setStep(step - 1);
    }, [step]);

    // BYPASS GUIDE
    useEffect(() => {
        history.replace('/wallet/create');
    }, []);

    const steps = [
        <BasicSlide
            imageSource='images/blockchain_logos.jpg'
            title='Blockchain'
            description='La blockchain sta diventanto sempre più presente nella vita di tutti i giorni perchè è in grado di creare nuove dinamiche di business garantendo decentralizzazione e trasparenza.'
        />,
        <BasicSlide
            imageSource='images/wallet.svg'
            title='Il Wallet'
            description='Il wallet rappresenta la tua identità su blockchain. Sfrutta la crittografia asimmetrica, pertanto è composto da una chiave pubblica e da una chiave privata in relazione fra loro.'
        >
            {/* <Player autoplay src={walletAnimation} /> */}
        </BasicSlide>,
        <BasicSlide
            title='La frase mnemonica'
            description='La frase mnemonica è una sequenza di parole, generalmente 12, che ti permette di recuperare il tuo wallet. Va conservata accuratamente e mantenuta segreta.'
        >
            <Mnemonic
                phrase={[
                    'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine',
                    'ten',
                    'eleven',
                    'twelve',
                ]}
            />
        </BasicSlide>,
        <BasicSlide
            title="L'address"
            description='Rappresenta il tuo identificativo su blockchain. Chiunque voglia trasferirti dei fondi o voglia interagire con te, dovrà fare riferimento a questo codice. Potrebbe essere considerato il tuo "IBAN" o il numero della tua carta d&apos;identità'
        >
            <Code p={2} borderRadius={5} fontSize='18px'>
                0xa46984723...7d341d38E6
            </Code>
        </BasicSlide>,
        <Center height='100%'>
            <Button>Iniziamo</Button>
        </Center>,
    ];

    return (
        <>
            <PageBody>
                <SwipeableViews
                    axis={'x'}
                    index={step}
                    onChangeIndex={handleStepChange}
                    enableMouseEvents
                >
                    {steps}
                </SwipeableViews>
            </PageBody>
            <BottomActions
                handlePrev={step > 0 ? handlePrev : undefined}
                handleNext={step > steps.length - 1 ? handleNext : undefined}
                labels={{
                    next: 'Prossimo',
                    prev: 'Indietro',
                }}
            />
        </>
    );
};

export default GuideScreen;

type BasicSlideProps = {
    imageSource?: string;
    title: string;
    description: string;
};

const BasicSlide: FunctionComponent<BasicSlideProps> = ({
    imageSource,
    description,
    title,
    children,
}) => (
    <>
        <Center overflow='hidden'>
            {imageSource && (
                <div className='image-wrapper'>
                    <img src={imageSource} className='App-logo' alt='logo' />
                </div>
            )}
            {!imageSource && children}
        </Center>
        <Center>
            <Heading>{title}</Heading>
        </Center>
        <Center>
            <Text align='center'>{description}</Text>
        </Center>
    </>
);
